import { type IOrder, Order, OrderFinancialStatus, OrderFulfillmentStatus } from '@/types/Order';
import axios from 'axios';
import type { APIResponse, RetrieveAllParams } from '~/api/utils';

const ORDERS_API_URL = `${import.meta.env.VITE_API_IDENTITY_URL}/order`;

interface ICreateOrderParams {
    mints: string[];
}

class OrdersService {
    async retrieveOrders(params?: RetrieveAllParams): Promise<APIResponse<Order>> {
        const response = await axios.get(`${ORDERS_API_URL}`, {
            params: {
                ...params,
            },
        });

        response.data.content = response.data.content.map((o: IOrder) => {
            return {
                shopifyOrderId: 'cdcdc',
                shopifyFinancialStatus: OrderFinancialStatus.PAID,
                shopifyFulfillmentStatus: OrderFulfillmentStatus.FULFILLED,
                email: 'hello@world.com',
                surname: 'Smith',
                phone: '+420224232323',
                orderNumber: o.orderNumber,
                userId: o.userId,
                shippingAddress: {
                    line1: 'Nová 32',
                    city: 'Prague',
                    country: 'Czech Republic',
                    zipCode: '15000',
                    state: 'Prague',
                },
                fulfillments: [
                    {
                        name: '#1009-F1',
                        id: 'gid://shopify/Fulfillment/7316655472905',
                        createdAt: '2025-02-20T13:31:25Z',
                        updatedAt: '2025-02-20T13:31:26Z',
                        totalQuantity: 3,
                        estimatedDeliveryAt: null,
                        deliveredAt: null,
                        trackingInfo: [
                            {
                                company: 'DHL Express',
                                number: '643264327643',
                                url: 'https://www.logistics.dhl/us-en/home/tracking.html?tracking-id=643264327643',
                            },
                            {
                                company: 'DHL Express',
                                number: '643264327643',
                                url: 'https://www.logistics.dhl/us-en/home/tracking.html?tracking-id=643264327643',
                            },
                        ],
                    },
                ],
                name: 'Thomas',
                totalPriceSet: {
                    presentmentMoney: {
                        amount: '100',
                        currencyCode: 'CZK',
                    },
                    shopMoney: {
                        amount: '4',
                        currencyCode: 'USD',
                    },
                },
                id: o.id,
                items: o.items,
            } as IOrder;
        });

        return {
            page: response.data.page,
            content: response.data.content.map((o: IOrder) => new Order(o)),
        };
    }

    async createOrder(data: ICreateOrderParams): Promise<APIResponse<Order>> {
        const response = await axios.post(`${ORDERS_API_URL}`, data);

        return response.data;
    }

    async retrieveOrder(id: string): Promise<APIResponse<Order>> {
        const response = await axios.get(`${ORDERS_API_URL}/${id}`);

        return response.data;
    }

    async prepareOrder(id: string, pdaList: string[]): Promise<APIResponse<Order>> {
        const queryParams = `pdaList=${pdaList.join(',')}`;
        const url = `${ORDERS_API_URL}/${id}/prepare?${queryParams}`;

        const response = await axios.post(url);

        return response.data;
    }

    async finalizeOrder(id: string): Promise<APIResponse<Order>> {
        const response = await axios.post(`${ORDERS_API_URL}/${id}/finalize`);

        return response.data;
    }

    async shipOrder(id: string): Promise<APIResponse<Order>> {
        const response = await axios.post(`${ORDERS_API_URL}/${id}/ship`);

        return response.data;
    }
}

export default new OrdersService();
